// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import { withStyles } from "@material-ui/core/styles";
import Heading1 from "../styleguide/Heading1";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        paddingBottom: 20,
        background: "linear-gradient(180deg, rgba(15,41,64,0.9) 0%, rgba(16,31,43,0.2) 100%)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center -150px",
        color: "#fff",
        minHeight: 550,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: 60,
    },
    heading: {
        marginBottom: 32,
        color: "#fff",
        textTransform: "uppercase",
        fontSize: 68,
        textAlign: "center",
    },
    text: {
        fontSize: 18,
        textAlign: "center",
        marginBottom: 24,
    },
    btn: {
        textAlign: "center",
        background: "#e40045",
        color: "#fff",
        border: "1px solid #e40045",
        minWidth: 45,
        width: 45,
        height: 45,
        borderRadius: 4,
        padding: 0,
        "& > span": {
            transform: "rotate(-90deg)",
        },
    },
    wrapper: {
        maxWidth: 750,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
});

const EMobilityBanner = ({ heading, description, classes, src, minHeight }) => {
    return (
        <div
            style={{
                flex: "1 0 auto",
                background: "#fafafa",
            }}
        >
            <div className={classes.containerStyle} style={{ backgroundImage: `url(${src})`, minHeight }}>
                <div className={classes.wrapper}>
                    <Heading1 className={classes.heading}>{heading}</Heading1>
                    <p className={classes.text}>{description}</p>
                </div>
            </div>
        </div>
    );
};

export default compose(withGeneralTranslations, withLocalization, withStyles(styles))(EMobilityBanner);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityBanner.js